import React from 'react';
import { twMerge } from 'tailwind-merge';

interface MoneyProps {
  className?: string;
  width?: number;
  height?: number;
}

const MoneyIcon = function MoneyIcon({
  className,
  width,
  height,
}: MoneyProps): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <rect className={twMerge(className, 'fill-transparent')} x="3" y="6" width="18" height="12" rx="2" stroke="#222222" />
      <path className={twMerge(className, 'fill-transparent')} d="M5 9H8" stroke="#222222" strokeLinecap="round" />
      <path className={twMerge(className, 'fill-transparent')} d="M16 15H19" stroke="#222222" strokeLinecap="round" />
      <circle className={twMerge(className, 'fill-transparent')} cx="12" cy="12" r="2" stroke="#222222" />
    </svg>
  );
};

MoneyIcon.defaultProps = {
  className: '',
  width: 24,
  height: 24,
};

export default MoneyIcon;
